// extracted by mini-css-extract-plugin
export default {"section":"axJH4n","background":"Sjqyhz","content":"nCD4ER","title":"ur3i2i","subtitle":"bCK22E","cta":"acOmCn"};